import { normalizeStreetNumber } from './normalizeStreetNumber';

// Did this parcel land in a building other than the titular's? True only when BOTH addresses reduce
// to a street and a number and those differ. Any side absent, empty or unreadable answers false:
// the degradation runs towards NOT warning, because a warning that never shows does no harm and one
// that asserts more than it knows teaches the agent to ignore the real ones.
export function isAddressMismatch(delivered: string | null, titular: string | null): boolean {
  const a = normalizeStreetNumber(delivered ?? '');
  const b = normalizeStreetNumber(titular ?? '');
  if (a === null || b === null) return false;
  return a.street !== b.street || a.number !== b.number;
}
